import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    if (typeof window === 'undefined') return;
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize fbq stub
    // @ts-ignore
    const n: any = function (...args: any[]) {
      // @ts-ignore
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    // @ts-ignore
    window.fbq = n;
    // @ts-ignore
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the script tag into <head>
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return null;
}